import React, { useEffect, useMemo, useState } from 'react'
import styles from './overview.module.css'
import CustomSelectButton from './CustomSelectButton';
import Tooltip from './Tooltip';
import useHttp from '../../../../hook/use-http';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates_bus';
import ChartLoader from '../MileageSarathiTab_bus/Loader_MS_bus';
import MultiCustomSelectButton from './MultiCustomSelect';


function Filter_MS_Overview({ filterData, setGraphData }) {

    const [tableData, setTableData] = useState([])
    const [vinNo, setVinNumber] = useState([])
    const [regNo, setRegNumber] = useState([])
    const [searchStr, setSearchStr] = useState("")
    const [lowPerforming, setLowPerforming] = useState(false)
    const [selectedField, setSelectedField] = useState("VIN_NUM")
    const { isLoading, error, sendReq: fetchData } = useHttp();
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

    useEffect(() => {
        submit(vinNo, regNo, searchStr)
    }, [filterData])


    const [clearFilters, setClearFilter] = useState(true)

    const clearFilter = () => {
        setRegNumber([])
        setVinNumber([])
        setSearchStr("")
        setLowPerforming(false)
        submit()
        setClearFilter(!clearFilters)
    }

    const updateFilter = (arr, index) => {
        setVinNumber(arr)
    }

    const updateFilterForREGNo = (arr, index) => {
        setRegNumber(arr)
    }

    const submit = (vinNo = [], regNo = [], str = "") => {

        setTableData([])
        let filterObj = {
            searchStr,
            ...filterData,
            CITY: filterData?.CITY?.length ? filterData?.CITY?.map(item => item?.value) : [],
            DEPO: filterData?.DEPO?.length ? filterData?.DEPO?.map(item => item?.value) : [],
            VIN_NUM: selectedField === "VIN_NUM" ? vinNo.map(item => item?.value) : [],
            REG_NUM: selectedField === "REG_NUM" ? regNo.map(item => item?.value) : []
        }

        let ApiURL = lowPerforming ? "fleet_summary_efficiency_below_40" : "overview_table_data"

        fetchData({
            url: API_URL_MAIN + `mileage_sarathi_overview/${ApiURL}`,
            body: {
                filterdata: {
                    ...filterObj,
                }
            }
        },
            (res) => {
                let data = res?.data.filter(item => item?.Distance?.value >= str) || []
                // if (lowPerforming) {
                //     data = data?.sort((a, b) => a.performance - b.performance) || []
                // }
                // if (lowPerforming) {
                setSortConfig({ key: "efficiency", direction: 'asc' })
                // }
                // else {
                //     setSortConfig({ key: null, direction: 'asc' })
                // }
                setTableData(data)
            }
        )
    }


    const sortTableData = () => {

        const { key, direction } = sortConfig
        let sorted = tableData
        if (key == "distance") {
            sorted = tableData.sort((a, b) => direction == "asc" ? a.Distance?.value - b.Distance?.value : b.Distance?.value - a.Distance?.value)
        }
        if (key == "consumption") {
            sorted = tableData.sort((a, b) => direction == "asc" ? a.Energy_Consumption?.value - b.Energy_Consumption?.value : b.Energy_Consumption?.value - a.Energy_Consumption?.value)
        }
        if (key == "efficiency") {
            sorted = tableData.sort((a, b) => direction == "asc" ? a.Energy_Efficiency?.value - b.Energy_Efficiency?.value : b.Energy_Efficiency?.value - a.Energy_Efficiency?.value)
        }
        return sorted
    };


    const requestSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }

        setSortConfig({ key, direction });
    };

    useEffect(() => {
        setGraphData(prev => ({ ...prev, monthWisePerformanceSummary: tableData }))
    }, [tableData])


    return (
        <>
            <div className={`p-3 ${styles.parameter_sel_tab}`}>
                <div className="row">
                    <div className="col-md-4 mb-3">
                        <div className="text-start"> {/* Ensures left-alignment */}
                            <div className={`${styles.parameter_distance}`}>
                                Minimum KM per day
                            </div>
                            <input
                                value={searchStr}
                                onChange={(e) => setSearchStr(e.target.value)}
                                type="text"
                                style={{ height: "35px" }}
                                className={`form-control`}
                                placeholder="Enter distance (km)"
                            />
                        </div>
                    </div>

                    <div className="col-md-4 mb-3">
                        <div className="text-start">
                            <div className={`${styles.parameter_distance} `}>
                                VIN/Reg. No.
                            </div>
                            <div className="d-flex">
                                <div className="flex-grow-1 me-2 ">
                                    <select className={`form-select  ${styles.filter_dropdown}`} value={selectedField} onChange={(e) => setSelectedField(e.target.value)}>
                                        <option value="VIN_NUM">VIN No.</option>
                                        <option value="REG_NUM">Reg. No.</option>
                                    </select>
                                </div>
                                <div className="flex-grow-1 w-50">
                                    {
                                        selectedField == "VIN_NUM" ?
                                            <MultiCustomSelectButton apiEnd="get_all_vin_num" clearFilters={clearFilters} filterdata={filterData} updateFilter={updateFilter} />
                                            :
                                            <MultiCustomSelectButton apiEnd="get_all_reg_num" clearFilters={clearFilters} filterdata={filterData} updateFilter={updateFilterForREGNo} />
                                    }
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-4 mb-3">
                        <div>
                            <div className={` ${styles.parameter_distance}`} style={{ textAlign: 'left', marginLeft: '30px' }}>
                                Vehicle Selection
                            </div>
                            <div className=" d-flex align-items-center" style={{ height: '38px' }}>
                                <label className={styles.checkboxWrapper_bus}>
                                    <input
                                        type="checkbox"
                                        className={styles.checkboxInput_bus}
                                        checked={lowPerforming}
                                        onChange={() => setLowPerforming(prev => !prev)}
                                        id="lowPerformingCheck"
                                    />
                                    Select Low Performing
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-6 text-start">
                        <button className="btn ms_btn_solid_Bus secondary" onClick={() => clearFilter()}>Clear Filter</button>
                    </div>
                    <div className="col-6 text-end">
                        <button
                            class="btn ms_btn_solid_Bus primary"

                            onClick={() => submit(vinNo, regNo, searchStr)}
                        >
                            APPLY
                        </button>
                    </div>
                </div>
            </div>

            <div className={`card mt-3 ${styles.vehicle_details}`}>
                <div className="" style={{ overflowY: "scroll", height: "350px", position: "relative" }}>
                    <table className={`table table-striped mb-0 ${styles.vehicle_details_table}`} style={{ overflowY: "scroll" }}>
                        <thead style={{ backgroundColor: '#83a4cf', color: '#fff', position: 'sticky', top: -1 }}>
                            <tr >
                                <th style={{ color: 'white', backgroundColor: '#83a4cf' }}>Vehicle Details</th>
                                <th
                                    style={{
                                        color: 'white',
                                        backgroundColor: '#83a4cf',
                                        cursor: 'pointer',
                                        position: 'relative'
                                    }}
                                >
                                    <Tooltip
                                        text="Disclaimer: Performance is calculated based on the number of days vehicle is driven in comparison with benchmark for the selected month."
                                        position="bottom"
                                    >
                                        Performance
                                        <i
                                            className="fas fa-info-circle ms-2"
                                        ></i>
                                    </Tooltip>
                                    <span className={`${styles.table_icons}`}>
                                        {sortConfig.key === 'performance'}
                                    </span>
                                </th>
                                <th
                                    style={{
                                        color: 'white',
                                        backgroundColor: '#83a4cf',
                                        cursor: 'pointer'
                                    }}
                                    onClick={() => requestSort('distance')}
                                >
                                    Distance
                                    <span className={`${styles.table_titles}`} style={{ marginLeft: '8px' }}>
                                        {sortConfig.key === 'distance' ? (
                                            sortConfig.direction === 'asc' ?
                                                <i className="fas fa-sort-up"></i> :
                                                <i className="fas fa-sort-down"></i>
                                        ) : (
                                            <i className="fas fa-sort"></i>
                                        )}
                                    </span>
                                </th>
                                <th
                                    style={{
                                        color: 'white',
                                        backgroundColor: '#83a4cf',
                                        cursor: 'pointer'
                                    }}
                                    onClick={() => requestSort('consumption')}
                                >
                                    Energy Consumed
                                    <span className={`${styles.table_titles}`} style={{ marginLeft: '8px' }}>
                                        {sortConfig.key === 'consumption' ? (
                                            sortConfig.direction === 'asc' ?
                                                <i className="fas fa-sort-up"></i> :
                                                <i className="fas fa-sort-down"></i>
                                        ) : (
                                            <i className="fas fa-sort"></i>
                                        )}
                                    </span>
                                </th>
                                <th
                                    style={{
                                        color: 'white',
                                        backgroundColor: '#83a4cf',
                                        cursor: 'pointer'
                                    }}
                                    onClick={() => requestSort('efficiency')}
                                >
                                    Energy Efficiency
                                    <span className={`${styles.table_titles}`} style={{ marginLeft: '8px' }}>
                                        {sortConfig.key === 'efficiency' ? (
                                            sortConfig.direction === 'asc' ?
                                                <i className="fas fa-sort-up"></i> :
                                                <i className="fas fa-sort-down"></i>
                                        ) : (
                                            <i className="fas fa-sort"></i>
                                        )}
                                    </span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {

                                isLoading ? <ChartLoader /> :
                                    sortTableData()?.length ?
                                        sortTableData()?.map((vehicle, index) => (
                                            <tr key={index}>
                                                <td>
                                                    <div className="d-flex justify-content-center align-content-center">
                                                        <div className="d-flex flex-column justify-content-start align-items-start">
                                                            <div>{vehicle.key.vehicleId}</div>
                                                            <div>{vehicle.key.vehicle_registration_number}</div>
                                                            <div>
                                                                <span className='small'>{vehicle.key.PL}</span><span>{" | "}</span>
                                                                <span className='small'>{vehicle.key.LOB}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>{vehicle.performance?.toFixed(2)} %</td>
                                                <td>{vehicle.Distance?.value} Kms </td>
                                                <td>{vehicle.Energy_Consumption?.value ? Math.round(vehicle.Energy_Consumption?.value) + "  KWh" : "--"}</td>
                                                <td>{vehicle.Energy_Efficiency?.value ? vehicle.Energy_Efficiency?.value?.toFixed(2) + " KWh/Km" : "--"} </td>
                                            </tr>
                                        )) :
                                        <tr> <td colSpan={6} className='text-center table-cell' > No Data found</td></tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    )
}

export default Filter_MS_Overview